import React from "react";
import { Fade, Typography, Box, Link } from "@mui/material";
import { useTranslation } from "react-i18next";

//* Componente que mostra uma mensagem de "Favorito salvo"
const FavoriteMessage = ({ show, changeTab }) => {
  const { t } = useTranslation();

  //Função para abrir componente com todas as atividades favoritadas
  const seeFavoriteActivities = () => {
    // window.scrollTo(0, 0); //Quando abrir da scroll para o início da página
    changeTab("", "FavoriteActivities");
  };


  return (
    // Animação de fade (aparece/desaparece suavemente)
    <Fade in={show} appear={false} timeout={{ enter: 300, exit: 300 }}>
      <Box
        sx={{
          position: "fixed",
          bottom: 100,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 9999,
          bgcolor: "white",
          color: "#662D91",
          px: 3,
          py: 2,
          minWidth: "527px",
          maxWidth: "700px",
          border: "1px solid #9149C7",
          borderRadius: 2,
          boxShadow: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: "500",
          whiteSpace: "nowrap",
        }}
      >
        {/* Texto da mensagem */}
        <Typography variant="body1" sx={{ fontWeight: 500 }}>
          {t("newActivities.favorite_saved_successfully")}
        </Typography>

        {/* Link clicável que chama a função*/}
        <Link
          onClick={seeFavoriteActivities}
          underline="hover"
          sx={{
            fontWeight: "500",
            color: "#0A7AFF",
            fontSize: "1rem",
            cursor: "pointer",
          }}
        >
          {t("newActivities.my_favorites")}
        </Link>
      </Box>
    </Fade>
  );
};

export default FavoriteMessage;
